export default {
  kiosk: {
    温馨提示: "温馨提示",
    继续点餐: "继续点餐",
    长时间未操作: "长时间未操作, {second} S后自动返回首页",
  },
};
